<template>
    <div>
        <transition name="page">
            <router-view />
        </transition>
    </div>
</template>

<script>
export default {
    name: 'JobsCutting',
}
</script>
